// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__YavQf","list":"styles_list__1QU4l"};